import get from 'lodash/get';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import countries from '../Country/country.list.json';

export const hasRegions = countryCode => !!get(countries, `${countryCode}.regions`);

export const getRegionList = countryCode =>
  sortBy(
    map(get(countries, `${countryCode.toUpperCase()}.regions`), ({ code, name }) => ({
      regionCode: code,
      regionName: name,
    })),
    region => region.regionName
  );

export const normalizeRegion = regionName =>
  regionName
    .replace(/[.\s]/g, '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

export const getRegionFromRegionName = ({ countryCode, regionName }) => {
  let region = { regionCode: '', regionName: '' };

  if (
    countryCode &&
    typeof countryCode === 'string' &&
    regionName &&
    typeof regionName === 'string'
  ) {
    const regions = getRegionList(countryCode);
    const normalizedRegion = normalizeRegion(regionName);

    // eslint-disable-next-line no-shadow
    regions.find(({ regionCode, regionName }) => {
      if (
        normalizedRegion === normalizeRegion(regionName) ||
        normalizedRegion === normalizeRegion(regionCode)
      ) {
        // eslint-disable-next-line no-return-assign
        return (region = { regionCode, regionName });
      }
      return false;
    });
  }
  return region;
};

export const getRegionCodeFromRegionName = ({ countryCode, regionName }) =>
  get(getRegionFromRegionName({ countryCode, regionName }), 'regionCode', '');
